import { render, staticRenderFns } from "./SiteAppsForgeAppInstalled.vue?vue&type=template&id=39ce4f36&scoped=true&"
import script from "./SiteAppsForgeAppInstalled.vue?vue&type=script&lang=js&"
export * from "./SiteAppsForgeAppInstalled.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppsForgeAppInstalled.vue?vue&type=style&index=0&id=39ce4f36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce4f36",
  null
  
)

export default component.exports